// extracted by mini-css-extract-plugin
export default {"th":"RateHistoryTable_th__j9dbv","tableBox":"RateHistoryTable_tableBox__dt345","table":"RateHistoryTable_table__mV7Kw","td":"RateHistoryTable_td__CXUI4"};